const LandingBrandLogoIcon = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="500 235 80 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="paint1_linear_16_37"
        x1="540"
        y1="240"
        x2="555"
        y2="260"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8D23C" />
        <stop offset="1" stopColor="#A2D56A" />
      </linearGradient>
    </defs>

    <path
      d="M 570.167 259.619 C 568.577 259.619 567.212 259.348 566.071 258.806 C 564.949 258.263 563.929 257.45 563.013 256.365 L 565.538 253.84 C 566.118 254.607 566.791 255.205 567.558 255.636 C 568.325 256.047 569.26 256.253 570.363 256.253 C 571.354 256.253 572.14 256.056 572.72 255.664 C 573.318 255.271 573.617 254.729 573.617 254.037 C 573.617 253.438 573.449 252.952 573.112 252.578 C 572.776 252.204 572.327 251.886 571.766 251.624 C 571.223 251.362 570.616 251.128 569.942 250.923 C 569.288 250.698 568.624 250.446 567.95 250.165 C 567.296 249.885 566.688 249.539 566.127 249.127 C 565.585 248.697 565.145 248.155 564.808 247.5 C 564.472 246.827 564.304 245.985 564.304 244.975 C 564.304 243.778 564.593 242.759 565.173 241.917 C 565.753 241.076 566.548 240.431 567.558 239.982 C 568.568 239.533 569.709 239.308 570.98 239.308 C 572.327 239.308 573.543 239.561 574.627 240.066 C 575.712 240.571 576.6 241.225 577.292 242.03 L 574.768 244.554 C 574.188 243.919 573.589 243.451 572.972 243.152 C 572.374 242.853 571.691 242.703 570.924 242.703 C 570.045 242.703 569.353 242.871 568.848 243.208 C 568.343 243.544 568.091 244.031 568.091 244.667 C 568.091 245.209 568.259 245.649 568.596 245.985 C 568.932 246.322 569.372 246.612 569.914 246.855 C 570.475 247.098 571.083 247.332 571.738 247.556 C 572.411 247.781 573.075 248.033 573.73 248.314 C 574.403 248.594 575.011 248.959 575.553 249.408 C 576.114 249.857 576.563 250.436 576.9 251.147 C 577.236 251.839 577.405 252.699 577.405 253.728 C 577.405 255.561 576.759 257.001 575.469 258.048 C 574.178 259.096 572.411 259.619 570.167 259.619 Z"
      fill="white"
    />
    <path
      d="M 508.358 259.123 L 508.358 239.822 L 512.201 239.822 L 512.201 259.123 L 508.358 259.123 Z M 502.074 242.795 L 502.074 239.401 L 518.485 239.401 L 518.485 242.795 L 502.074 242.795 Z"
      fill="white"
    />
    <path
      d="M 515.683 259.123 L 523.622 239.401 L 526.736 239.401 L 534.647 259.123 L 530.58 259.123 L 524.464 242.936 L 525.867 242.936 L 519.667 259.123 L 515.683 259.123 Z M 519.891 255.448 L 519.891 252.25 L 530.495 252.25 L 530.495 255.448 L 519.891 255.448 Z"
      fill="white"
    />
    <path
      d="M 532.095 256.224 L 532.095 242.172 L 535.296 242.172 L 536.676 244.89 L 536.676 256.224 L 532.095 256.224 Z M 548.465 256.224 L 534.42 245.43 L 535.296 242.172 L 549.34 252.966 L 548.465 256.224 Z M 548.465 256.224 L 547.152 253.585 L 547.152 242.172 L 551.766 242.172 L 551.766 256.224 L 548.465 256.224 Z"
      fill="url(#paint1_linear_16_37)"
      style={{ transformBox: 'fill-box', transformOrigin: '50% 50%' }}
      transform="matrix(0, -1, 1, 0, -0.000002, -0.000002)"
    />
    <path
      d="M 549.147 259.093 L 549.147 239.371 L 552.962 239.371 L 552.962 259.093 L 549.147 259.093 Z"
      fill="url(#paint1_linear_16_37)"
    />
    <path
      d="M 555.358 250.898 L 555.358 238.61 L 559.402 238.61 L 559.402 250.898 L 555.358 250.898 Z"
      fill="url(#paint1_linear_16_37)"
      style={{ transformBox: 'fill-box', transformOrigin: '50% 50%' }}
      transform="matrix(0.707107, 0.707107, -0.707107, 0.707107, -0.000009, 0.000021)"
    />
    <path
      d="M 555.132 259.705 L 555.132 247.417 L 558.896 247.417 L 558.896 259.705 L 555.132 259.705 Z"
      fill="url(#paint1_linear_16_37)"
      style={{ transformOrigin: '557.014px 253.561px' }}
      transform="matrix(-0.707107, 0.707107, -0.707107, -0.707107, 0.00004, -0.000027)"
    />
  </svg>
);

export default LandingBrandLogoIcon;
